import { api } from '@/lib/api'

export type OpActionResult = {
  run_id: string
  status: string
  changes: { action: string; target: string }[]
  warnings: string[]
  confirm_token?: string | null
  atlassian_silent_failure: boolean
  blast_radius?: { change_count: number; projects: number; summary: string } | null
  required_fields?: Record<
    string,
    { name: string | null; required: boolean; allowed_values: string[] | null }
  > | null
}

// First POST (no token): a mutating op returns status="awaiting_confirm" + confirm_token
// (the gate's preview). A no-op / below-gate op may return success directly.
export function previewOpAction(op: string, params: Record<string, unknown>): Promise<OpActionResult> {
  return api<OpActionResult>(`/ops/${op}`, {
    method: 'POST',
    body: JSON.stringify({ ...params, dry_run: false }),
  })
}

// Second POST (with token): consumes the token and applies.
export function confirmOpAction(
  op: string,
  params: Record<string, unknown>,
  token: string,
): Promise<OpActionResult> {
  return api<OpActionResult>(`/ops/${op}`, {
    method: 'POST',
    body: JSON.stringify({ ...params, dry_run: false, confirm_token: token }),
  })
}
